import { green, orange } from '@mui/material/colors';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Chip } from 'shared/mui/Chips';
import { Stack } from 'shared/mui/Stack/Stack';
import { BooleanStatusChipField, FunctionField } from 'shared/react-admin/Fields';
import { Merchant } from 'types/embedded/merchant';

export const MerchantsShowCommonInformationChipFields: React.FC = () => {
  const translate = useTypedTranslate();

  return (
    <Stack direction="row" gap={1} sx={{ marginBottom: '24px' }}>
      <FunctionField
        render={(record: Merchant) => <Chip label={`ID: ${record?.originId}`} size="small" />}
      />
      <FunctionField
        render={({ name }: Merchant) => (
          <Chip label={`${translate('app.merchants.name')}: ${name}`} size="small" />
        )}
      />
      <BooleanStatusChipField
        disabledColor={green[500]}
        disabledLabel={translate('app.merchants.activeStatus')}
        enabledColor={orange[800]}
        enabledLabel={translate('app.statuses.archive')}
        source="archive"
      />
    </Stack>
  );
};
